import React, { useCallback, useEffect, useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import SweetAlert from "react-bootstrap-sweetalert";

const ModalHasilChecklist = ({ showHasilChecklist, handleCloseHasilChecklist, dataDisposisi, dataPrimer, jenisIzin, reloadList, isEdit }) => {
    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [totalSesuai, setTotalSesuai] = useState('')
    const [totalMinor, setTotalMinor] = useState('')
    const [totalMayor, setTotalMayor] = useState('')
    const [totalKritis, setTotalKritis] = useState('')
    const [totalHasil, setTotalHasil] = useState('')
    const [keterangan, setKeterangan] = useState('')
    const [valueTglInspeksi, setValueTglInspeksi] = useState(null)
    const [listKritis, setListKritis] = useState([])
    const [listMayor, setListMayor] = useState([])
    const [listMinor, setListMinor] = useState([])

    const columnsKritis = [
        {
            name: 'Persyaratan',
            cell: row => (
                <div className="row">
                    <div className="col-12">
                        <b>{row['uraianChecklistHeader']}</b> -
                        &nbsp;&nbsp;{row['uraianCheckHeaderSub']} -
                        &nbsp;&nbsp;{row['uraianChecklistKomponen']}
                        &nbsp;&nbsp;{row['uraianChecklistKomponenSub']}
                    </div>
                </div>
            )
        },
    ]
    const columnsMayor = [
        {
            name: 'Persyaratan',
            cell: row => (
                <div className="row">
                    <div className="col-12">
                        <b>{row['uraianChecklistHeader']}</b> -
                        &nbsp;&nbsp;{row['uraianCheckHeaderSub']} -
                        &nbsp;&nbsp;{row['uraianChecklistKomponen']}
                        &nbsp;&nbsp;{row['uraianChecklistKomponenSub']}
                    </div>
                </div>
            )
        },
    ]
    const columnsMinor = [
        {
            name: 'Persyaratan',
            cell: row => (
                <div className="row">
                    <div className="col-12">
                        <b>{row['uraianChecklistHeader']}</b> -
                        &nbsp;&nbsp;{row['uraianCheckHeaderSub']} -
                        &nbsp;&nbsp;{row['uraianChecklistKomponen']}
                        &nbsp;&nbsp;{row['uraianChecklistKomponenSub']}
                    </div>
                </div>
            )
        },
    ]

    const fetchAllData = useCallback(async () => {
        if (!dataDisposisi?.idProses || !dataPrimer?.nomorAju || dataDisposisi?.idDisposisi !== 7) {
            return
        }
        try {
            const resInspeksi = await pbumkuService.getUmkuInspeksiDataByAjuAndIdProses(dataPrimer.nomorAju, dataDisposisi.idProses)
            if (resInspeksi.data !== null) {
                setValueTglInspeksi(resInspeksi.data.tglInspeksi)

                const resInspeksiHasil = await pbumkuService.getUmkuHasilInspeksiByAjuAndIdInspeksi(dataPrimer.nomorAju, resInspeksi.data.idInspeksi)
                if (resInspeksiHasil.data !== null) {
                    setTotalSesuai(resInspeksiHasil?.data?.totalSesuai)
                    setTotalMinor(resInspeksiHasil?.data?.totalMinor)
                    setTotalMayor(resInspeksiHasil?.data?.totalMayor)
                    setTotalKritis(resInspeksiHasil?.data?.totalKritis)
                    setTotalHasil(resInspeksiHasil?.data?.totalHasil)
                    setKeterangan(resInspeksiHasil?.data?.keterangan)
                }

                const result = await Promise.allSettled([
                    pbumkuService.listUmkuChecklistByIdInspeksiAndNilai(resInspeksi.data.idInspeksi, 0),
                    pbumkuService.listUmkuChecklistByIdInspeksiAndNilai(resInspeksi.data.idInspeksi, 2),
                    pbumkuService.listUmkuChecklistByIdInspeksiAndNilai(resInspeksi.data.idInspeksi, 3)
                ])
                const [resKritis, resMayor, resMinor] = result
                const getData = (res, fallback = []) =>
                    res.status === "fulfilled"
                        ? res.value?.data?.data ?? res.value?.data ?? fallback
                        : fallback;
                setListKritis(getData(resKritis))
                setListMayor(getData(resMayor))
                setListMinor(getData(resMinor))
            }
        } catch (error) {

        }

    }, [pbumkuService, dataDisposisi, dataPrimer])

    useEffect(() => {
        let isMounted = true
        if (!dataPrimer) return

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataPrimer, fetchAllData])

    const handleClickClose = () => {
        handleCloseHasilChecklist()
    }

    const [showConfirmReviu, setShowConfirmReviu] = useState(false)
    const handleCloseConfirmReviu = () => setShowConfirmReviu(false)
    const handleClickConfirmReviu = () => setShowConfirmReviu(true)
    const [loadingProses, setLoadingProses] = useState(false)
    const [showProcessReviuSuccess, setShowProcessReviuSuccess] = useState(false)
    const [showProcessReviuFailed, setShowProcessReviuFailed] = useState(false)

    const handleClickProcessReviu = async () => {
        setLoadingProses(true)
        try {
            let dataHeader = await pbumkuService.getUmkuHeader(dataPrimer.nomorAju)

            let jsonDisposisi = {
                nomorAju: dataPrimer.nomorAju,
                noTugas: dataDisposisi?.noTugas,
                tglTugas: new Date(),
                idDisposisi: 8,
                createdBy: localStorage.getItem('userId'),
                createdDate: new Date()
            }
            const resDispo = await pbumkuService.saveUmkuPenugasan(jsonDisposisi)
            if(resDispo.data.kode === '200'){
                let jsonUmkuStatus = {
                    nomorAju: dataPrimer.nomorAju,
                    kodeStatus: '026',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                await pbumkuService.saveUmkuStatus(jsonUmkuStatus)

                jsonUmkuStatus = {
                    nomorAju: dataPrimer.nomorAju,
                    kodeStatus: '027',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                await pbumkuService.saveUmkuStatus(jsonUmkuStatus)

                let jsonHeader = {
                    ...dataHeader?.data,
                    kodeStatus: '027'
                }
                await pbumkuService.saveUmkuHeader(jsonHeader)

                setShowConfirmReviu(false)
                setShowProcessReviuSuccess(true)
            }
        } catch (error) {
            setShowConfirmReviu(false)
            setShowProcessReviuFailed(true)
        }
        setLoadingProses(false)
    }

    const handleCloseReviuSuccess = () => {
        setShowProcessReviuSuccess(false)
        handleCloseHasilChecklist()
        reloadList(dataPrimer.nomorAju)
    }

    const handleCloseReviuFailed = () => {
        setShowProcessReviuFailed(false)
    }

    return (
        <>
            <Modal
                show={showHasilChecklist}
                onHide={handleCloseHasilChecklist}
                size="xl"
                centered
                scrollable
            >
                <Modal.Header><Modal.Title><h5>Hasil Inspeksi {jenisIzin}</h5></Modal.Title></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPrimer?.nomorAju} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Inspeksi</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="date" placeholder="NIB" className="form-control-sm" value={valueTglInspeksi} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Total Ketidaksesuaian</strong></label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-1 col-form-label-sm">Sesuai</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="sesuai" value={totalSesuai} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Minor</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="minor" value={totalMinor} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Mayor</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="mayor" value={totalMayor} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Kritis</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="kritis" value={totalKritis} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Hasil / Nilai Kuantitaif</strong></label>
                        <div className="col-sm-3">
                            <input type="text" className="col-sm-12 form-control-sm" name="hasil" value={totalHasil} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Keterangan</label>
                        <div className="col-sm-3">
                            <input type="text" className="col-sm-12 form-control-sm" name="keterangan" value={keterangan} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Data Checklist</strong></label>
                    </div>
                    <div className="row">
                        <label className="col-sm-4 col-form-label-sm"><strong>Kritis</strong></label>
                    </div>
                    <div className="table-responsive border-bottom">
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columnsKritis}
                            data={listKritis}
                            highlightOnHover
                        />
                    </div>
                    <div className="row">
                        <label className="col-sm-4 col-form-label-sm"><strong>Mayor</strong></label>
                    </div>
                    <div className="table-responsive border-bottom">
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columnsMayor}
                            data={listMayor}
                            highlightOnHover
                        />
                    </div>
                    <div className="row">
                        <label className="col-sm-4 col-form-label-sm"><strong>Minor</strong></label>
                    </div>
                    <div className="table-responsive border-bottom">
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columnsMinor}
                            data={listMinor}
                            highlightOnHover
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && dataPrimer?.kodeStatus === '025' && <Button variant="primary" size="sm" onClick={() => handleClickConfirmReviu()}>Proses Reviu & Rekom Teknis</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmReviu &&
                <SweetAlert
                    title="Lanjut Reviu & Rekomendasi Teknis?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingProses ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickProcessReviu}
                    onCancel={handleCloseConfirmReviu}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingProses}
                    reverseButtons
                >
                    {loadingProses && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showProcessReviuSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data  Berhasil"
                    onConfirm={handleCloseReviuSuccess}
                    btnSize="sm"
                />
            }
            {
                showProcessReviuFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseReviuFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalHasilChecklist